import React from "react";
import { cn } from "../lib/utils";

const STYLES = {
  // Payment statuses — parent-friendly labels
  unpaid:    "bg-rose-50 text-rose-700 border border-rose-200",
  submitted: "bg-amber-50 text-amber-800 border border-amber-200",
  confirmed: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  rejected:  "bg-rose-100 text-rose-800 border border-rose-300",
  waived:    "bg-slate-100 text-slate-700 border border-slate-200",
  // Charge statuses — Active / Archived / Canceled
  active:    "bg-brand-50 text-brand border border-brand/30",
  archived:  "bg-slate-100 text-slate-700 border border-slate-200",
  // Canceled keeps a red pop so it stays visually loud even when the
  // parent card / row is grayed out around it.
  canceled:  "bg-rose-100 text-rose-800 border border-rose-300",
  draft:     "bg-slate-100 text-slate-700 border border-slate-200",
};

const LABELS = {
  unpaid:    "Unpaid",
  submitted: "To Review",
  confirmed: "Paid",
  rejected:  "Rejected",
  waived:    "Waived",
  active:    "Active",
  archived:  "Archived",
  canceled:  "Canceled",
  draft:     "Draft",
};

export default function StatusBadge({ status, className }) {
  const style = STYLES[status] || "bg-slate-100 text-slate-700 border border-slate-200";
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-1 text-xs font-bold uppercase tracking-wide",
        style,
        className,
      )}
      data-testid={`status-badge-${status}`}
    >
      {LABELS[status] || status}
    </span>
  );
}
